import API from "@/services/api";
import { ContractListInfo } from "../types/contractSelectFields";

enum Endpoints {
  LlistatContractes = "/contracts/list-info/",
}

const getContractList = async () => {
  try {
    const response = await API.get<
      ContractListInfo
    >({
      endpoint: Endpoints.LlistatContractes,
      versions: [2]
    });
    return {
      status: response.promise.status,
      data: response.promise.data
    };
  } catch (error) {
    throw new Error("Failed to get the contract list of electricity and gas. Please try again later.");
  }
};

export default {
  getContractList
};
